import { Helmet } from "react-helmet-async";

const SITE_URL = "https://happytiddlers.co.uk";
const OG_IMAGE = "https://static.prod-images.emergentagent.com/jobs/0fcceaa6-1521-494d-b839-5c40b3586ed4/images/3976524776ba2465d28c24ce28bc7c2bf6f25964e0213271506ee30cf191414c.png";

const businessSchema = {
  "@context": "https://schema.org",
  "@type": "SportsActivityLocation",
  name: "Happy Tiddlers Swim School",
  description:
    "Fun, confidence-building swimming lessons for babies, children and adults in Barton-le-Clay, Bedfordshire. STA 'Swim Star' school since 2014.",
  url: SITE_URL,
  telephone: "+441582883820",
  image: OG_IMAGE,
  logo: `${SITE_URL}/logo.png`,
  priceRange: "££",
  address: {
    "@type": "PostalAddress",
    addressLocality: "Barton-le-Clay",
    addressRegion: "Bedfordshire",
    addressCountry: "GB",
  },
  areaServed: "Barton-le-Clay, Bedfordshire",
  sameAs: [
    "https://www.facebook.com/happytiddlers/",
    "http://instagram.com/tiddlertastic",
  ],
};

export const Seo = ({ title, description, path = "/", schema }) => {
  const canonical = `${SITE_URL}${path === "/" ? "" : path}`;
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />

      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={OG_IMAGE} />

      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />

      <script type="application/ld+json">{JSON.stringify(businessSchema)}</script>
      {schema && <script type="application/ld+json">{JSON.stringify(schema)}</script>}
    </Helmet>
  );
};
